import { enterAnimation, leaveAnimation } from 'utils/slideAnimation';

export default {
  methods: {
    enterAnimation,
    leaveAnimation,
  }
};
